<template>
  <button class="notification-item p-ripple" v-ripple>
    <span class="notification-item-title text-ellipsis" :title="props.title">
      <img :src="MessageCircleSvg" />
      {{ notificationTitle }}
      <span class="pi pi-chevron-right"></span>
    </span>
  </button>
</template>

<script setup>
import {computed} from 'vue';
import MessageCircleSvg from "../assets/images/message-circle.svg";

const props = defineProps({
  notification: {type: Object, required: true}
});

const notificationTitle = computed(() => {
    switch (props.notification.type) {
      case 'MessageNotification':
        return 'Message'
      case 'SubmittedAdArchiveNotification':
        return 'Archive created'
    }

    return '';
  }
);

const notificationText = computed(() => {
    switch (props.notification.type) {
      case 'MessageNotification':
        return props.notification.data.content;
    }

    return '';
  }
);

</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.notification-item {
  font-size: toRem(14);
  border-radius: calc($borderRadius / 2);
  cursor: pointer;
  border: 0;
  background: none;
  text-align: left;
  width: 100%;

  &:hover {
    background-color: $gray;
  }
}

.notification-item-title {
  display: flex;
  font-size: toRem(14);
  font-weight: 500;
  align-items: center;
  height: toRem(36);

  img {
    margin-right: toRem(10);
  }

  span {
    margin-left: auto;
    font-size: toRem(12);
  };
}

.notification-item-text {
  display: block;
  opacity: 0.7;
}


</style>
